<!-- Modal Require Holidays -->
<ng-template #content let-modal>
    <div [formGroup]="formGroup">
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modalClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"REQUIRE_NEW_HOLIDAY" | translate}}</h3>
            <div class="form-group mb-1">
                <label [for]="'type'">{{"TYPE_HOLIDAY" | translate}}<sup class="text-danger">*</sup></label>
                <ng-select (change)="checkAdditionalInput(); formGroup.patchValue({note: ''});" formControlName="type" id="type"
                           [bindLabel]="'name'" [bindValue]="'id'" class="{{fieldHasErrors('type') ? 'is-invalid' : ''}}"
                           [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                           [items]="absenceTypesList"
                           [openOnEnter]="false" [virtualScroll]="true">
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.type.errors?.required">
                    {{"ERRORS.INSERT_TYPE_HOLIDAY" | translate}}
                </div>
            </div>
            <div class="form-group mb-1">
                <label for="from">{{"FROM" | translate}}<sup class="text-danger">*</sup></label>
                <ng2-flatpickr id="from" [ngClass]="'from'" [config]="basicDateOptions" formControlName="from">
                </ng2-flatpickr>
            </div>
            <div class="form-group mb-1">
                <label for="to">{{"TO" | translate}}<sup class="text-danger">*</sup></label>
                <ng2-flatpickr id="to" [setDate]="formGroup.value.from" [ngClass]="'to'" [config]="basicDateOptions" formControlName="to">
                </ng2-flatpickr>
            </div>
            <div *ngIf="requireNote" class="form-group mb-1">
                <label for="note">{{"NOTE" | translate}}<sup class="text-danger">*</sup></label>
                <textarea class="form-control" name="note" id="note" cols="45" rows="3" formControlName="note"></textarea>
            </div>
            <div *ngIf="requireFile" class="form-group mb-1">
                <fieldset>
                    <label for="file">{{'INSERT.UPLOAD_DOCUMENT' | translate}}</label>
                    <div class="custom-file">
                        <input class="custom-file-input" type="file" lang="it" id="file" accept="application/pdf" (change)="handlerChangeFileInput($event)"/>
                        <label *ngIf="!fileName" class="custom-file-label">{{"SELECT_FILE" | translate}}</label>
                        <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{fileName}}</label>
                    </div>
                </fieldset>
            </div>
            <div>
                <a class="font-small-3 text-primary" (click)="showVideo()">
                    {{'DONT_KNOW_HOW_TO_DO'|translate}}
                </a>
            </div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
                {{"CANCEL" | translate}}
            </button>
            <button type="submit" (click)="sendAbsenceRequest()" class="btn btn-primary w-150" rippleEffect>
                {{"SEND" | translate}}
            </button>
        </div>
    </div>
</ng-template>
<!-- / Modal Require Holidays -->